import { Divider } from "pepsico-ds";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ButtonGroupDynamic from "../../../../common/ButtonGroupDynamic";
import { STORE_SELECTION_TYPES } from "./storeOutcomeUtils";

/**
 * Read-only summary of a configured store condition, rendered under the outcome
 * once a Store/Store Group has been selected. Reads straight from the persisted
 * `store_configuration` (no reconstruction needed).
 */
export default function StoreConditionDisplay({
  ruleData,
  onEdit,
  onDelete,
  readOnly,
}) {
  const { t } = useTranslation("StoreOutcome");
  const config = ruleData?.store_configuration;

  if (!config?.stores?.length) {
    return null;
  }

  const { selection_type, category, stores } = config;
  const isGroup = selection_type === STORE_SELECTION_TYPES.STORE_GROUP;
  const categoryLabel = category || t("MultipleStoreGroups");

  return (
    <div className="store-condition-display" data-testid="store-condition-display">
      <Divider
        style={{ margin: "16px 0", backgroundColor: "rgba(0, 92, 188, 0.2)" }}
      />
      <div className="store-condition-display__header">
        <div className="store-condition-display__header-left">
          <span className="store-condition-display__name">{categoryLabel}</span>
          <span className="store-condition-display__badge">
            {isGroup ? t("StoreGroupBadge") : t("StoreBadge")}
          </span>
        </div>
        {!readOnly && (
          <ButtonGroupDynamic
            size="small"
            items={[
              { icon: "edit", onClick: onEdit },
              { icon: "delete", onClick: onDelete },
            ]}
          />
        )}
      </div>
      <div className="store-condition-display__meta">
        <span className="store-condition-display__arrow">↳</span>
        <span>{t("StoreCount", { count: stores.length })}</span>
      </div>
    </div>
  );
}

StoreConditionDisplay.propTypes = {
  ruleData: PropTypes.shape({
    keywords: PropTypes.arrayOf(PropTypes.string),
    store_configuration: PropTypes.shape({
      selection_type: PropTypes.string,
      category: PropTypes.string,
      stores: PropTypes.arrayOf(PropTypes.object),
    }),
  }),
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  readOnly: PropTypes.bool,
};

StoreConditionDisplay.defaultProps = {
  ruleData: null,
  readOnly: false,
};
